export function menuMain() {
    const menu = document.querySelector('#menu-main');
    const menuToggle = document.querySelector('#menu-toggle');
    const breakpoint = '1200px';

    if (!menu || !menuToggle) return;

    // Works regardless of whether the container class changes per language
    const navRoot =
        menu.closest('nav') ||
        menu.closest('[class*="menu-primary-nav"]') ||
        menuToggle.closest('nav') ||
        menuToggle.closest('[class*="menu-primary-nav"]') ||
        menu.parentElement;

    if (!navRoot) return;

    menuToggle.addEventListener('click', () => {
        const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
        const next = !expanded;

        menuToggle.setAttribute('aria-expanded', String(next));
        menu.classList.toggle('visible', next);

        if (!next) closeAllSubmenus();
    });

    // Delegate clicks on submenu toggles
    menu.addEventListener('click', (e) => {
        const btn = e.target.closest('.submenu-toggle');
        if (!btn || !menu.contains(btn)) return;

        e.preventDefault();
        toggleSubmenu(btn);
    });

    // Keyboard support
    menu.addEventListener('keydown', (e) => {
        const btn = e.target.closest('.submenu-toggle');
        if (!btn || !menu.contains(btn)) return;

        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleSubmenu(btn, { focusFirstItem: true });
            return;
        }

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            openSubmenu(btn, { focusFirstItem: true });
            return;
        }

        if (e.key === 'Escape') {
            e.preventDefault();
            closeSubmenu(btn, { returnFocus: true });
        }
    });

    // Close on click outside nav
    document.addEventListener('click', (e) => {
        if (!navRoot.contains(e.target)) closeAllSubmenus();
    });

    // ESC anywhere: close submenu first, else close mobile menu
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;

        const openBtn = menu.querySelector('.submenu-toggle[aria-expanded="true"]');
        if (openBtn) {
            closeSubmenu(openBtn, { returnFocus: true });
            return;
        }

        const mainExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        if (mainExpanded) {
            menuToggle.setAttribute('aria-expanded', 'false');
            menu.classList.remove('visible');
            closeAllSubmenus();
            menuToggle.focus();
        }
    });

    function toggleSubmenu(btn, opts = {}) {
        const expanded = btn.getAttribute('aria-expanded') === 'true';

        if (expanded) {
            closeSubmenu(btn);
            return;
        }

        closeAllSubmenus(btn);
        openSubmenu(btn, opts);
    }

    function openSubmenu(btn, { focusFirstItem = false } = {}) {
        const panel = getPanel(btn); // now returns .submenu-wrapper
        if (!panel) return;

        cancelCloseTimer(panel);

        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.setAttribute('data-anim', 'in');

        if (focusFirstItem) {
            // Prefer focusing first item in submenu list, but allow feature panel focusables too.
            const firstFocusable =
                panel.querySelector('.submenu a, .submenu button, .submenu [tabindex]:not([tabindex="-1"])') ||
                panel.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

            if (firstFocusable) firstFocusable.focus();
        }
    }

    function closeSubmenu(btn, { returnFocus = false } = {}) {
        const panel = getPanel(btn);
        if (!panel) return;

        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('data-anim', 'out');

        setCloseTimer(panel, () => {
            panel.hidden = true;
            panel.removeAttribute('data-anim');
        });

        if (returnFocus) btn.focus();
    }

    function closeAllSubmenus(exceptBtn) {
        menu.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach((b) => {
            if (exceptBtn && b === exceptBtn) return;
            closeSubmenu(b);
        });
    }

    function getPanel(btn) {
        const id = btn.getAttribute('aria-controls');
        if (!id) return null;
        return document.getElementById(id); // this should be the submenu-wrapper
    }

    const CLOSE_DELAY = 160;

    function setCloseTimer(panel, fn) {
        cancelCloseTimer(panel);
        const t = window.setTimeout(fn, CLOSE_DELAY);
        panel.dataset.closeTimer = String(t);
    }

    function cancelCloseTimer(panel) {
        const t = panel.dataset.closeTimer;
        if (!t) return;
        window.clearTimeout(Number(t));
        delete panel.dataset.closeTimer;
    }

    // Optional: close on desktop breakpoint
    const mq = window.matchMedia('(min-width: ' + breakpoint + ')');
    mq.addEventListener?.('change', () => {
        if (!mq.matches) return;

        menu.classList.remove('visible');
        menuToggle.setAttribute('aria-expanded', 'false');
        closeAllSubmenus();
    });
}
